import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back.");
      const dest = location.state?.from || (u.role === "admin" ? "/admin" : "/dashboard");
      navigate(dest);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-5 py-12">
      <div className="w-full max-w-md card-surface p-8">
        <Link to="/" className="flex items-center justify-center gap-2 mb-6">
          <Sparkles className="text-brand-gold" /><span className="font-display text-3xl font-semibold">Isoharts</span>
        </Link>
        <h1 className="font-display text-3xl font-semibold text-center text-brand-ink">Welcome Back</h1>
        <p className="text-center text-brand-muted text-sm mt-1">Log in to your member portal.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input data-testid="login-email" type="email" required placeholder="Email" className="input-field"
            value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" type="password" required placeholder="Password" className="input-field"
            value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="login-submit" disabled={loading} className="btn-primary w-full">
            {loading ? "Logging in…" : "Log In"}
          </button>
        </form>
        <div className="mt-4 flex items-center justify-between text-sm">
          <Link to="/forgot-password" className="text-brand-sage hover:underline" data-testid="forgot-link">Forgot password?</Link>
          <Link to="/signup" className="text-brand-sage hover:underline" data-testid="to-signup">Join Free</Link>
        </div>
      </div>
    </div>
  );
}
